export default {
  manage_deleteLocation: "Eliminar Ubicación",
  manage_deleteLocations: "Eliminar Ubicaciones",
  manage_deletedLocation: "Ubicación eliminada exitosamente",
  manage_deletedLocations: "Ubicaciones eliminadas exitosamente",
  manage_deleteManageLocation_confirmationMessage:
    "¿Está seguro de que desea eliminar los siguientes Ubicaciones?",
  manage_deleteManageLocation_transferUnits:
    "Se han encontrado unidades asignadas en la(s) Ubicación(es) que se eliminan. Seleccione una nueva Ubicación para estas unidades.",
  manage_deleteManageLocation_toReceive: "Ubicación libre para las Unidades",
  manage_deleteManageLocation_toReceive_placeholder: "Seleccionar Ubicación"
};
